<template>
<!-- 售后服务-详情-客服不在 -->
    <div class="content">
        <div class="NoCustomerService">
            <img src="../assets/icon_touxiang@2x.png" alt="客服">
            <div>对不起,客服人员不在线！请稍后接入!</div>
            <div>您也可以直接拨打</div>
            <div>售后客户热线咨询：18518635777</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
.content {
    padding: 28px;
    font-size: 34px;
    letter-spacing: 4px;
}
.NoCustomerService {
    padding: 28px;
    background: #fff;
    border-radius: 25px;
}
.NoCustomerService img {
    display: block;
    margin: 0 auto;
    width: 96px;
}
.NoCustomerService div {
    text-align: center;
    margin-bottom: 22px;
}
.NoCustomerService div:first-of-type {
    margin: 40px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/NoCustomerService.vue